// 对应 sidebar-07 的 NavProjects：当前空间最近的 demo，悬停出现「⋯」快捷操作；收起为图标时隐藏。
import { useQuery } from "@tanstack/react-query";
import { FileVideo, MoreHorizontal } from "lucide-react";
import { Link, useLocation } from "react-router";
import { DemoActionsMenu } from "@/features/demo/demo-actions";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSkeleton,
  useSidebar,
} from "@/components/ui/sidebar";
import { ep, qk, type DemoListFilter } from "@/lib/api/endpoints";
import { demoTitle } from "@/lib/format";
import { useSpace } from "@/lib/space";

const LIMIT = 5;

export function NavRecent() {
  const { space } = useSpace();
  const { isMobile } = useSidebar();
  const { pathname } = useLocation();
  const f: DemoListFilter = space.kind === "team" ? { team_id: space.team.id, status: "ready", limit: LIMIT } : { owner_type: "user", status: "ready", limit: LIMIT };
  const q = useQuery({ queryKey: qk.demos(f), queryFn: () => ep.demos(f), staleTime: 30_000 });
  const items = q.data?.items ?? [];

  if (q.isSuccess && items.length === 0) return null;

  return (
    <SidebarGroup className="group-data-[collapsible=icon]:hidden">
      <SidebarGroupLabel className="font-display font-semibold tracking-[0.08em] uppercase text-muted-foreground">最近 demo</SidebarGroupLabel>
      <SidebarMenu>
        {q.isPending
          ? Array.from({ length: 3 }, (_, i) => (
              <SidebarMenuItem key={i}>
                <SidebarMenuSkeleton showIcon />
              </SidebarMenuItem>
            ))
          : items.map((d) => {
              const base = `/demos/${d.id}`;
              return (
                <SidebarMenuItem key={d.id}>
                  <SidebarMenuButton asChild isActive={pathname === base || pathname.startsWith(`${base}/`)}>
                    <Link to={base} title={demoTitle(d)}>
                      <FileVideo />
                      <span>{demoTitle(d)}</span>
                    </Link>
                  </SidebarMenuButton>
                  {/* 与 Demo 库、回放页同一套操作菜单 */}
                  <DemoActionsMenu
                    demo={d}
                    side={isMobile ? "bottom" : "right"}
                    align={isMobile ? "end" : "start"}
                    trigger={
                      <SidebarMenuAction showOnHover aria-label={`${demoTitle(d)} 的操作`}>
                        <MoreHorizontal />
                      </SidebarMenuAction>
                    }
                  />
                </SidebarMenuItem>
              );
            })}
        {q.data?.next_cursor ? (
          <SidebarMenuItem>
            <SidebarMenuButton asChild className="text-sidebar-foreground/70">
              <Link to="/demos">
                <MoreHorizontal className="text-sidebar-foreground/70" />
                <span>全部 demo</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ) : null}
      </SidebarMenu>
    </SidebarGroup>
  );
}
